import { createFileRoute } from "@tanstack/react-router";
import { ArticlePage } from "@/components/ArticlePage";
import { articleSchemas, qaSchema } from "@/lib/seo";

const UPDATED = "2026-10-14";
const ANSWER = "Bei Shopify fallen vier Arten von Kosten an: der monatliche Tarif, Gebühren pro Zahlung, Kosten für Apps und einmalig ein Theme. Die genaue Höhe hängt vom gewählten Tarif und den Zahlungsarten ab und steht aktuell auf der offiziellen Preisseite von Shopify. Den größten Hebel haben Sie meist bei den Apps.";
const SITE = "https://shopify-freelancer.net";
const PATH = "/fragen/shopify-gebuehren";
const TITLE = "Welche Gebühren fallen bei Shopify an?";
const DESCRIPTION = "Shopify Gebühren verständlich erklärt: monatlicher Tarif, Zahlungsgebühren, App-Kosten und Theme. Was davon Sie wirklich beeinflussen können.";

const faqs = [
  { q: "Gibt es versteckte Gebühren?", a: "Versteckt nicht, aber leicht übersehen: Apps und Gebühren für externe Zahlungsanbieter summieren sich schnell." },
  { q: "Wann lohnt ein größerer Tarif?", a: "Wenn die niedrigeren Zahlungsgebühren im größeren Tarif Ihre monatliche Mehrkosten übersteigen. Das lässt sich mit Ihrem Umsatz einfach durchrechnen." },
  { q: "Kostet Shopify Payments extra?", a: "Für Zahlungen fallen Gebühren an. Die aktuelle Höhe steht auf der Preisseite von Shopify." },
];

export const Route = createFileRoute("/fragen/shopify-gebuehren")({
  component: Page,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: [
      ...articleSchemas({ title: TITLE, description: DESCRIPTION, path: PATH, faqs, section: "Shopify Kosten", updated: UPDATED, breadcrumb: { name: "Fragen", path: "/fragen" } }),
      qaSchema({ question: TITLE, answer: ANSWER, path: PATH, updated: UPDATED }),
    ],
  }),
});

function Page() {
  return (
    <ArticlePage
      kicker="Frage · Gebühren"
      title={TITLE}
      intro="Kurz gesagt: Tarif, Zahlungsgebühren, Apps und Theme. Den Tarif legt Shopify fest, bei Apps und Zahlungsarten haben Sie selbst viel Spielraum."
      source="frage-shopify-gebuehren"
      answer={ANSWER}
      updated={UPDATED}
      breadcrumb={{ to: "/fragen", label: "Fragen" }}
      sections={[
        { h: "Die vier Kostenarten", p: [], list: ["Monatlicher Tarif: abhängig vom Funktionsumfang", "Zahlungsgebühren: pro Bestellung, je nach Tarif und Zahlungsart", "Apps: meist monatliche Abos, oft der unterschätzte Posten", "Theme: kostenlos oder einmalig kostenpflichtig"] },
        { h: "Wo Sie sparen können", p: ["Viele Shops zahlen für Apps, die kaum genutzt werden. Eine App-Prüfung zeigt schnell, was weg kann. Bei den Zahlungsgebühren lohnt ein Blick darauf, welche Zahlungsarten Ihre Kunden wirklich nutzen."] },
        { h: "Aktuelle Preise prüfen", p: ["Shopify passt Tarife und Gebühren regelmäßig an. Verbindlich ist immer die offizielle Preisseite von Shopify. Ich bin unabhängiger Freelancer und kein Teil von Shopify."] },
      ]}
      faqs={faqs}
      related={[{ to: "/fragen/was-kostet-ein-shopify-shop", label: "Was kostet ein Shopify-Shop?" }, { to: "/fragen/welcher-shopify-tarif", label: "Welcher Tarif passt?" }, { to: "/fragen/welche-shopify-apps-brauche-ich", label: "Welche Apps brauche ich?" }]}
    />
  );
}
